import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bookingsApi from '@/features/dashboard/bookings/api/bookingsApi.ts';
import { bookingsApiQueryKeys } from '@/features/dashboard/bookings/api/bookingsApi.queryKeys.ts';
import { ParticipantSelectionsDto } from '@/features/dashboard/bookings/types/ParticipantSelectionsDto.ts';

/** Wybory kompletu uczestników rezerwacji jednym żądaniem. */
const useGetBookingParticipantSelections = (bookingId: string | undefined) =>
  useQuery(getBookingParticipantSelectionsQueryOptions(bookingId));

export const getBookingParticipantSelectionsQueryOptions = (
  bookingId: string | undefined,
): UseQueryOptions<ParticipantSelectionsDto[]> => ({
  queryKey: bookingsApiQueryKeys.participantSelections(bookingId ?? ''),
  queryFn: () => bookingsApi.getParticipantSelections(bookingId!),
  enabled: !!bookingId,
  staleTime: 1000 * 60,
});

export default useGetBookingParticipantSelections;
